



















































































































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import { AxiosResponse } from 'axios';

import Section from '@/components/Bulma/Section.vue';
import Columns from '@/components/Bulma/Columns.vue';
import Column from '@/components/Bulma/Column.vue';
import ProductCard from '@/components/ProductCard.vue';
import EditCollectedProductDesktop from '@/components/EditCollectedProductDesktop.vue';
import EditCollectedProductMobile from '@/components/EditCollectedProductMobile.vue';
import CollectedProductCard from '@/components/CollectedProductCard.vue';

import Product from '@/types/Product';
import User from '@/types/User';
import CollectedProduct from '@/types/CollectedProduct';

import Util from '@/util/Util';

import UserAPI from '@/services/UserAPI';
import CollectionAPI from '@/services/CollectionAPI';
import Amount from '@/types/Amount';

export default Vue.extend({
	name: 'Collection',

	components: {
		Section,
		ProductCard,
		Columns,
		Column,
		EditCollectedProductDesktop,
		EditCollectedProductMobile,
		CollectedProductCard
	},

    props: {
        collectionId: {
            type: String,
            default: ''
        }
	},

	created() {
		Util.updateHeaders((this as any).$text('yourCollection'), (this as any).$text('seeYourCollection'), process.env.VUE_APP_DEFAULT_IMAGE);

		if (!Util.isEmpty(this.collectionId)) {
			this.getUserCollection(this.collectionId);
		}
    },

	mounted() {
		window.onresize = () => {
			this.windowWidth = window.innerWidth;
		};
	},

    data() {
		return {
			filterType: 'All',
			isLoading: '',
			userCollection: new Array<CollectedProduct>(),
			selectedProductId: '',
			windowWidth: window.innerWidth
		};
	},

	computed: {
		...mapState(['language']),

        ...mapGetters(['getCollectionSupportedLanguageCountries']),

		user(): User {
			return this.$store.state.user;
		},

		products(): Product[] {
			return this.$store.state.products;
		},

		isSignedIn(): boolean {
			return this.$store.getters.isSignedIn;
		},

		numberProductsCollection(): number {
			return this.$store.getters.numberProductsCollection;
		},

		totalPurchaseAmount(): Amount {
			const amount = new Amount();
			amount.value = 0;
			amount.currencyCode = this.$store.state.user.defaultCurrencyCode;
			return this.$store.state.user.collectedProducts.reduce( ( previousAmount: Amount, collectedProduct: CollectedProduct ) => {
				previousAmount.value += collectedProduct.totalPurchaseAmount.value;
				previousAmount.currencyCode = collectedProduct.totalPurchaseAmount.currencyCode;
				return previousAmount;
			}, amount);
		},

		totalEstimatedAmount(): Amount {
			const amount = new Amount();
			amount.value = 0;
			amount.currencyCode = this.$store.state.user.defaultCurrencyCode;
			return this.$store.state.user.collectedProducts.reduce( ( previousAmount: Amount, collectedProduct: CollectedProduct ) => {
				previousAmount.value += collectedProduct.totalEstimatedValueAmount.value;
				previousAmount.currencyCode = collectedProduct.totalEstimatedValueAmount.currencyCode;
				return previousAmount;
			}, amount);
		}
	},

	watch: {
		'user.collectedProducts': {
            handler(after, before) {
                if (!this.isCollected(this.selectedProductId)) {
					this.selectedProductId = '';
				}
            },
            deep: true
        }
	},

    methods: {
		isMobile(): boolean {
			return this.windowWidth < 1023;
		},

		getUserCollectedProduct(productId: string): CollectedProduct {
			if (this.user.collectedProducts) {
            	return this.user.collectedProducts.find((collectedProduct: CollectedProduct) => collectedProduct.productId === productId) as CollectedProduct;
			} else {
				return new CollectedProduct();
			}

        },

		isCollected(productId: string): boolean {
			if (Util.isEmpty(this.collectionId)) {
				return this.$store.getters.isCollected(productId);
			} else {
				return this.userCollection && this.userCollection.filter((product: CollectedProduct) => product.productId === productId).length > 0;
			}
		},

		filteredProducts(): Product[] {
			return this.products
				.filter((product: Product) => {
					if ( this.filterType === 'All' ) {
						return true;
					} else if (this.filterType === 'OnlyCollected') {
						return this.isCollected(product.productId);
					} else if (this.filterType === 'NotCollected') {
						return !this.isCollected(product.productId);
					}
				});
		},

		setFilter(filterType: string): void {
			this.filterType = filterType;
		},

        updateCollectionAccess(status: boolean): void {

            const handleResponse = (response: AxiosResponse) => {
                    if (response.data) {
						this.$store.commit('setUser', response.data.user);
                    }
                };

            if (status) {
                UserAPI
                    .postCollectAccess()
                    .then(handleResponse);
            } else {
                UserAPI
                    .deleteCollectAccess()
                    .then(handleResponse);

            }
		},

		getUserCollection(collectionId: string): void {

			const handleResponse = (response: AxiosResponse) => {
				if (response.data) {
					this.userCollection = response.data;
				}
			};

			this.isLoading = 'collection';
			CollectionAPI
				.getCollection(collectionId)
				.then(handleResponse)
				.finally(() => this.isLoading = '');
		},

		getCollectionLink(): void {
			prompt((this as any).$text('shareLink'), `${process.env.VUE_APP_URL}${this.$route.path}/${this.user.collectionId}`);
		},

		isEmpty(word: string): boolean {
			return Util.isEmpty(word);
		},

		selectCollectedProduct(productId: string): void {
			this.selectedProductId = productId;
			setTimeout(() => { Util.scrollToElementWithId('selected-collected-product'); }, 200);
		},

		updateUserDefaultCurrency(event: any): void {
			const user = new User();
			user.defaultCurrencyCode = event.target.value;
			UserAPI
				.patchUser(this.user.userId, user)
				.then((response: AxiosResponse) => {
                    if (response.data) {
						this.$store.commit('setUser', response.data);
                    }
                });

		}
	}
});
